import { Checkbox  } from '@fluentui/react';
import { Dialog,DialogType, DialogFooter } from '@fluentui/react';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';

import "./DevOpsUIConfirmDialog.css";
import SingleIdentityPickerExtension from '../Controls/BreadCrumbExtension/IdentityPicker/SingleIdentityPickerExtension'
import { TextField } from 'office-ui-fabric-react/lib/TextField';

import { useState, useEffect, useRef, useCallback } from 'react'
import { flushSync } from "react-dom";
// import { useMsal, useAccount } from "@azure/msal-react";

// Dialog form state props
interface IConfirmDialogProps {
    title: string;
    subText?: string,
    ccid?: string,
    content:string,
    showDialog: boolean;
    onConfirmDialogDismiss: () => void;
    onConfirmDialogSubmit: (reason?: string) => void;
}

// const USER_SELECTION_ERROR: string = 'User Selection cannot be empty';
const DESCRIPTION_ERROR: string = 'This description cannot be empty';
const DEFAULT_DESCRIPTION_VALUE = 'The content has been modified by using Chiron.';

export default function DevOpsUIConfirmDialog(props: IConfirmDialogProps){
    const [confirmChecked, setConfirmChecked] = useState<boolean>(true);
    const [showUserCard, setShowUserCard] = useState<boolean>(false);
    const [descriptionError, setDescriptionError] = useState<string>('');
    // const [userSelectionError, setUserSelectionError] = useState<string>('');
    const [descriptionValue, setDescriptionValue] = useState<string>(DEFAULT_DESCRIPTION_VALUE);
    // const [hasUserError, setHasUserError] = useState<string>('');
    const firstRenderFlag = useRef<number>(0);

    /** Import msal-react for getting login user information */
    // const { accounts } = useMsal();
    // const userAccount = useAccount(accounts[0]);
    // const [user, setUser] = useState<string>(userAccount.username);

    // const identityPickerChange = useCallback((data: string)=>{
    //     setUser(data)
    // },[])

    const resetDialog = () =>{
        setConfirmChecked(false)
        setDescriptionError('')
        // setUserSelectionError('')
        // setHasUserError('')
    }

    const onDismiss = () => {
        flushSync(()=>{
            resetDialog()
        })
        props.onConfirmDialogDismiss()
    };

    const onSubmit = () => {
        if(confirmChecked) {
            if(descriptionValue) {
                props.onConfirmDialogSubmit(descriptionValue)
            }else {
                setDescriptionError(DESCRIPTION_ERROR)
                return
            }
        }else {
            props.onConfirmDialogSubmit()
        }
    }

    // useEffect(() =>{
    //     if(!user && firstRenderFlag.current > 0) {
    //         setUserSelectionError(USER_SELECTION_ERROR)
    //     }else {
    //         setUserSelectionError('')
    //     }
    // },[user])

    useEffect(() =>{
        if(!descriptionValue && firstRenderFlag.current > 0) {
            setDescriptionError(DESCRIPTION_ERROR);
        }else {
            setDescriptionError('');
        }
    },[descriptionValue])

    useEffect(()=>{
        if(confirmChecked) {
            setShowUserCard(true)
        }else {
            setShowUserCard(false)
        }
    },[confirmChecked])

    // useEffect(()=>{
    //     if(userSelectionError) {
    //         setHasUserError('confirm_dialog_user_error')
    //     }else {
    //         setHasUserError('')
    //     }
    // },[userSelectionError])

    useEffect(()=>{
        firstRenderFlag.current ++;
    },[])

    return (
        <div>
            {
                props.showDialog &&
                (
                    <Dialog
                        modalProps={{
                            containerClassName: 'confirm_dialog_main',
                            isBlocking: true
                        }}
                        dialogContentProps={{
                            title: "Confirm"
                        }}
                        hidden={false}
                        onDismiss={onDismiss}
                    >
                        <div>
                            <span>{props.content}</span>
                            {
                                !props.ccid && (
                                    <>
                                        <Checkbox
                                            label='Add a history record for this change at the end of the content'
                                            className='confirm_dialog_checkbox'
                                            checked={confirmChecked}
                                            onChange={(event,checked) => {setConfirmChecked(checked)}}
                                        >
                                        </Checkbox>
                                        <div className="flex-grow bolt-card flex-column depth-8 bolt-card-white confirm_user_card">
                                            <TextField label="Description"
                                                required={true}
                                                disabled={!showUserCard}
                                                errorMessage={descriptionError}
                                                multiline rows={4}
                                                value={descriptionValue}
                                                onChange={(e, newValue) => { setDescriptionValue(newValue) }}
                                            />
                                        
                                        </div>
                                    </>
                                )
                            }
                        </div>
                        
                        <DialogFooter>
                            <DefaultButton onClick={onSubmit}>Approve</DefaultButton>
                            <PrimaryButton onClick={onDismiss}>Cancel</PrimaryButton>
                        </DialogFooter>
                    </Dialog>
                )
            }
        </div>
    )
}